import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import "./blockchain-admin-ui.css";

const XOSO_MODES = [
    {
        id: "xs75s",
        label: "Xổ số 75 giây (1 Sảnh)",
        path: "/admin/setxs75s",
        tablesCount: 1,
        tableLetters: ["1"]
    },
    {
        id: "xs120s",
        label: "Xổ số 120 giây (1 Sảnh)",
        path: "/admin/setxs120s",
        tablesCount: 1,
        tableLetters: ["1"]
    }
];

export default function XoSoHeaderNav({ currentMode = "xs75s", currentSanh = 1 }) {
    const navigate = useNavigate();
    const activeModeObj = XOSO_MODES.find(m => m.id === currentMode) || XOSO_MODES[0];
    const sanhNum = Number(currentSanh) || 1;

    return (
        <Box 
            className="classic-game-room-tabs" 
            sx={{ 
                mb: 2.5, 
                p: 1.5, 
                bgcolor: "#ffffff", 
                border: "1px solid #e2e8f0", 
                borderRadius: "12px", 
                display: "flex !important", 
                flexDirection: "column !important", 
                gap: 1.2,
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
            }}
        >
            {/* Hàng 1: Chọn thể loại Xổ số */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Typography sx={{ fontSize: 13, color: "#64748b", fontWeight: 600, minWidth: 70 }}>
                    Thể loại:
                </Typography>
                {XOSO_MODES.map((mode) => {
                    const isActive = mode.id === currentMode;
                    return (
                        <Button
                            key={mode.id}
                            size="small"
                            variant={isActive ? "contained" : "outlined"}
                            onClick={() => navigate(`${mode.path}?sanh=1`)}
                            sx={{
                                borderRadius: "8px",
                                textTransform: "none",
                                fontSize: "13px",
                                fontWeight: isActive ? 600 : 400,
                                bgcolor: isActive ? "#2563eb !important" : "#ffffff !important",
                                color: isActive ? "#ffffff !important" : "#334155 !important",
                                borderColor: isActive ? "#2563eb !important" : "#cbd5e1 !important",
                                boxShadow: isActive ? "0 2px 4px rgba(37,99,235,0.2)" : "none",
                                "&:hover": {
                                    bgcolor: isActive ? "#1d4ed8 !important" : "#f8fafc !important",
                                    borderColor: isActive ? "#1d4ed8 !important" : "#94a3b8 !important"
                                }
                            }}
                        >
                            {mode.label}
                        </Button>
                    );
                })}
            </Box>

            {/* Hàng 2: Chọn sảnh */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", pt: 1, borderTop: "1px dashed #e2e8f0" }}>
                <Typography sx={{ fontSize: 13, color: "#64748b", fontWeight: 600, minWidth: 70 }}>
                    Chọn sảnh:
                </Typography>
                {Array.from({ length: activeModeObj.tablesCount }, (_, i) => i + 1).map((tableId) => {
                    const letter = activeModeObj.tableLetters[tableId - 1] || tableId;
                    const isActive = tableId === sanhNum;
                    return (
                        <Button
                            key={tableId}
                            size="small"
                            variant={isActive ? "contained" : "outlined"}
                            onClick={() => navigate(`${activeModeObj.path}?sanh=${tableId}`)}
                            sx={{
                                borderRadius: "8px",
                                fontWeight: isActive ? 600 : 400,
                                fontSize: "13px",
                                textTransform: "none",
                                bgcolor: isActive ? "#059669 !important" : "#ffffff !important",
                                borderColor: isActive ? "#059669 !important" : "#cbd5e1 !important",
                                color: isActive ? "#ffffff !important" : "#334155 !important",
                                minWidth: "75px",
                                "&:hover": {
                                    bgcolor: isActive ? "#047857 !important" : "#f8fafc !important",
                                    borderColor: isActive ? "#047857 !important" : "#94a3b8 !important"
                                }
                            }}
                        >
                            Sảnh {letter}
                        </Button>
                    );
                })}
            </Box>
        </Box>
    );
}
